module.exports = __webpack_public_path__ + "img/蒙版组 1@2x_副本2.61803f6f.webp";